import "./LatestEvents.html";
import "./LatestEvents.scss";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import LatestEventsComponentController from "./LatestEventsComponentController";

export class LatestEventsComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = LatestEventsComponentController;
        this.templateUrl = "/App/Components/Site/Overview/LatestEvents/LatestEvents.html";
    }
}

module("mmManagePortal").component("mmLatestEvents", new LatestEventsComponent());
